import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "24",
        height: "23",
        viewBox: "0 0 24 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11.9937 14.676C13.8153 14.676 15.292 13.1993 15.292 11.3777C15.292 9.55604 13.8153 8.07932 11.9937 8.07932C10.172 8.07932 8.69531 9.55604 8.69531 11.3777C8.69531 13.1993 10.172 14.676 11.9937 14.676Z",
                stroke: "#EE6D07",
                strokeWidth: 1.5,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1 12.3451V10.4101C1 9.26666 1.93453 8.32113 3.08896 8.32113C5.07896 8.32113 5.89255 6.91383 4.89205 5.1877C4.32034 4.19819 4.66117 2.91184 5.66167 2.34012L7.56372 1.25167C8.43228 0.734924 9.55372 1.04277 10.0705 1.91134L10.1914 2.12023C11.1809 3.84637 12.8081 3.84637 13.8086 2.12023L13.9295 1.91134C14.4463 1.04277 15.5677 0.734924 16.4363 1.25167L18.3383 2.34012C19.3388 2.91184 19.6797 4.19819 19.1079 5.1877C18.1074 6.91383 18.921 8.32113 20.911 8.32113C22.0545 8.32113 23 9.25566 23 10.4101V12.3451C23 13.4885 22.0655 14.4341 20.911 14.4341C18.921 14.4341 18.1074 15.8414 19.1079 17.5675C19.6797 18.568 19.3388 19.8434 18.3383 20.4151L16.4363 21.5035C15.5677 22.0203 14.4463 21.7124 13.9295 20.8439L13.8086 20.635C12.8191 18.9088 11.1919 18.9088 10.1914 20.635L10.0705 20.8439C9.55372 21.7124 8.43228 22.0203 7.56372 21.5035L5.66167 20.4151C4.66117 19.8434 4.32034 18.557 4.89205 17.5675C5.89255 15.8414 5.07896 14.4341 3.08896 14.4341C1.93453 14.4341 1 13.4885 1 12.3451Z",
                stroke: "#EE6D07",
                strokeWidth: 1.5,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
export default Icon;
